import styled from "styled-components";
import { colors } from "../../theme/color";
import { IoTriangleSharp } from "react-icons/io5";

export const ProductContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 50vw;

  background-color: ${colors.White};
  z-index: 10000;
  padding: 1.5rem;
  gap: 1rem;
  border-radius: 0.65rem;
  @media only screen and (max-width: 767px) {
    padding: 2.5rem;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    padding: 3rem;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;
export const Product = styled.div`
  display: flex;
  align-items: center;
  width: 22%;
  gap: 0.5rem;
  color: ${colors.BLACK};
  & :hover {
    color: #00c703;
  }
`;
export const ProductIconWrapper = styled.div`
  margin: 0;
  border-radius: 50%;
  background-color: #e7e6ef;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  @media only screen and (max-width: 767px) {
    width: 100%;
    height: 100%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    height: 100%;
  }
`;
export const IoTriangleSharpStyle = styled(IoTriangleSharp)`
  position: absolute;
  top: -13%;
  right: 89%;
  color: ${colors.White};
  @media only screen and (max-width: 767px) {
    top: -4%;
    right: 70%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    top: -4%;
    right: 70%;
  }
`;
